import OnlineOrderValuesModel from "../../../../services/models/formModels/onlineOrderValues.model";
import CustomText from "../../../atomic/CustomText";
import DetailRenderer from "../DetailRenderer";

function PatientInformationReview({
  values,
}: {
  values: OnlineOrderValuesModel;
}): JSX.Element {
  return (
    <div id="patient info">
      <CustomText
        text="Patient Information"
        fontWeight="font-medium"
        className="reviewCardHeading my-5"
      />
      <div className="reviewCard">
        <DetailRenderer
          data={{
            firstName: values.patientInfo.firstName,
            middleInitial: values.patientInfo.middleInitial,
            lastName: values.patientInfo.lastName,
            dateOfBirth: values.patientInfo.birthDate,
            sexAtBirth: values.patientInfo.gender,
          }}
          groupFields={[
            "firstName",
            "middleInitial",
            "lastName",
            "dateOfBirth",
            "sexAtBirth",
          ]}
          hiddenFields={[]}
          obsecureFields={[
            "firstName",
            "middleInitial",
            "lastName",
            "dateOfBirth",
            "sexAtBirth",
          ]}
          MainHeading="Patient Information"
          // approval={true}
        />
        {values?.testTypeId === 4 && (
          <DetailRenderer
            data={{
              ssn: values.patientInfo.securityInfo.ssn ?? "",
              mrn: values.patientInfo.securityInfo.mrn ?? "",
            }}
            groupFields={["ssn", "mrn"]}
            hiddenFields={[]}
            obsecureFields={["ssn", "mrn"]}
            MainHeading="Additional Patient Identifier (Optional)"
            // approval={true}
          />
        )}
        <DetailRenderer
          data={{
            address: values.patientInfo.address,
            city: values.patientInfo.city,
            state: values.patientInfo.state,
            zipcode: values.patientInfo.zipcode,
            phone: values.patientInfo.phone,
            email: values.patientInfo.email,
          }}
          groupFields={[
            "zipcode",
            "address",
            "city",
            "state",
            "phone",
            "email",
          ]}
          hiddenFields={[]}
          obsecureFields={["zipcode", "address", "city", "state", "phone"]}
          MainHeading="Patient Contact Information"
        />
      </div>
    </div>
  );
}
export default PatientInformationReview;
